import React from 'react';
import { Phone, Mail } from 'lucide-react';
import { businessInfo } from '../mock';

const TopBar = () => {
  return (
    <div className="hidden md:flex fixed top-0 left-0 right-0 z-[60] bg-slate-900 text-slate-200 text-sm h-11 items-center">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full flex items-center justify-end gap-8">
        <a
          href={`tel:${businessInfo.phoneRaw}`}
          className="flex items-center gap-2 hover:text-blue-400 transition-colors duration-200"
        >
          <Phone size={14} className="text-blue-500" />
          {businessInfo.phone}
        </a>
        <a
          href={`mailto:${businessInfo.email}`}
          className="flex items-center gap-2 hover:text-blue-400 transition-colors duration-200"
        >
          <Mail size={14} className="text-blue-500" />
          {businessInfo.email}
        </a>
      </div>
    </div>
  );
};

export default TopBar;
